import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { PreviewSheet } from "./PreviewSheet";

export type PreviewEntity = "Lead" | "Deal" | "Account" | "Contact";
interface Target {
  entity: PreviewEntity;
  id: string;
}
interface PreviewApi {
  open: (entity: PreviewEntity, id: string) => void;
  close: () => void;
  current: Target | null;
}

const Ctx = createContext<PreviewApi>({ open: () => undefined, close: () => undefined, current: null });
export const usePreview = () => useContext(Ctx);

/** One quick-look panel for the whole app: any list opens it with `open(entity, id)` */
export function PreviewProvider({ children }: { children: React.ReactNode }) {
  const [current, setCurrent] = useState<Target | null>(null);
  const open = useCallback((entity: PreviewEntity, id: string) => setCurrent({ entity, id }), []);
  const close = useCallback(() => setCurrent(null), []);
  const value = useMemo(() => ({ open, close, current }), [open, close, current]);
  return (
    <Ctx.Provider value={value}>
      {children}
      <PreviewSheet target={current} onClose={close} />
    </Ctx.Provider>
  );
}
